import isAndroid from './isAndroid';
import isFireFox from './isFireFox';

const isTablet = (): boolean => {
  const ua = navigator.userAgent;
  return (
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid() && !/(?:Mobile)/.test(ua)) ||
    (isFireFox() && /(?:Tablet)/.test(ua))
  );
};

export default isTablet;
